module.exports = __webpack_public_path__ + "static/media/004-shopping-bag.e00684de.svg";